import Image from 'next/image'

import usePopularSearches from '@hooks/usePopularSearches'
import { seoUrlPathEncode } from '@lib/helpers/client'

import ArrowIcon from './arrow.svg'

import styles from './popular-searches-list.module.scss'
import { Country } from '@types'
import Link from 'next/link'

export default function PopularSearchesList({
  onClick,
  locale,
}: {
  onClick: () => void
  locale: Country
}): JSX.Element {
  const { data } = usePopularSearches(6)
  return (
    <>
      {Array.isArray(data) &&
        data?.map((item, i) => (
          <Link
            href={`/${locale}/jobs/all-locations/${seoUrlPathEncode(item?.microRoles, 'role')}`}
            className={styles.item}
            onClick={onClick}
            key={i}
          >
            {item?.microRoles}
            <Image src={ArrowIcon} alt="Arrow icon" />
          </Link>
        ))}
    </>
  )
}

export const PopularSearchesLoading = (): JSX.Element => {
  return (
    <>
      {[...Array(6)]
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .map((_, i) => (
          <div className={styles.item} key={i}>
            <span className={styles.loading} />
            <Image src={ArrowIcon} alt="Arrow icon" />
          </div>
        ))}
    </>
  )
}
